import React, { ReactNode } from 'react';
import { Box, SxProps, Theme, Toolbar } from '@mui/material';

interface HeaderProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const Header: React.FC<HeaderProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        minWidth: 0,
        maxWidth: '100%',
        p: 1,
        backgroundColor: '#ffffff',
        width: '98%',
        mx: 'auto',
        boxSizing: 'border-box',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {/* <Toolbar disableGutters /> */}
      {children}
    </Box>
  );
};

export default Header;
